import React, { memo, ReactElement } from "react";
import { OtherPaymentsV4 } from "./v4";
interface OtherPaymentsProps {
    couponCode?: string;
    rewardName?: string;
    onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
    hideTitle?: boolean;
    heading?: string;
    iconUrl?: string;
    containerClassName?: string;
    onLoad?: () => void;
}

function OtherPayments(props: OtherPaymentsProps): ReactElement {
    return <OtherPaymentsV4 {...props} />;
}

export default memo(OtherPayments);
